// extracted by mini-css-extract-plugin
export default {"text-area":"input_text-area__gApWU","input":"input_input__oLcr5","error":"input_error__b8-U8"};